module.exports = __webpack_public_path__ + "media/no2.b34cfba0.mp3";